import { createSelector } from 'reselect';
import { AppState } from '../store/types/Store';
import { getViewIndex } from './commonSelectors';
import { getCurrentSeason } from './seasonSelectors';
import { PLANTING } from '../constants/mapLayerIds';
import { ColorsMap } from '../types/FieldRegionReport';
import { IntervalWithStringValue } from '../types';

export const getLayersState = (state: AppState) => state.layers;

export const getActiveMapLayers = (state: AppState) => state.layers.activeMapLayers;

const getLayersList = (state: AppState) => state.layers.list;

export const getCurrentLayerName = createSelector(
  [getActiveMapLayers,
    getViewIndex],
  (activeMapLayers, index) => activeMapLayers[index]?.name ?? ''
);

export const getCurrentLayerId = createSelector(
  [getActiveMapLayers,
    getViewIndex],
  (activeMapLayers, index) => activeMapLayers[index]?.id ?? ''
);

export const getCurrentSeasonLayer = createSelector(
  [getLayersList, getCurrentSeason],
  (layersList, getCurrentSeason) => layersList?.[getCurrentSeason]
);

export const getCurrentSeasonHybridsColor = createSelector(
  [getCurrentSeasonLayer],
  (currentSeasonLayer) => {
    const legends: IntervalWithStringValue[] = currentSeasonLayer?.[PLANTING.HYBRID]?.legend ?? [];

    return legends.reduce<ColorsMap>((acc, legend) => {
      if (legend.stringValue) {
        const { r: red, g: green, b: blue} = legend;
        acc[legend.stringValue] = { red, green, blue, alpha: 1 };
      }
      return acc;
    }, {});
  }
);
